export default {

    methods: {
      resetBar: function(){
        this.$store.state.bar = { search: false, exportToExcel: false, add: false, birthday: false, view: false, setting: false, refresh: false, menuinputplaceholder: '' }
        this.$store.state.heading = ""
        this.$store.state.searchTerm = ""
      },
      timer: function(name) {
        var start = new Date();
        var development = this.$store.state.development;
        if(development){
          console.log('+++++++++ Timer:', name, 'started');
        }    
        return {
          stop: function() {
            if(development){
              var end  = new Date();
              var time = end.getTime() - start.getTime();
              console.log('--------- Timer:', name, 'finished in', time, 'ms');
            }
          }
        }
      },
      
      sayHello: function() {
        console.log('hello from mixin!')
      }

    },
    mounted() {
      //this.sayHello()
    }

  }


// (function ($) {

//     Array.prototype.unique = function() {
//         var arr = [];
//         for(var i = 0; i < this.length; i++) {
//             if(!arr.includes(this[i])) {
//                 arr.push(this[i]);
//             }
//         }
//         return arr; 
//     }

//     function replaceUmlaute(str){
//         let mapObj = {
//             ae:"ä",
//             oe:"ö",
//             ue:"ü",
//             Ae:"Ä",
//             Oe:"Ö",
//             Ue:"Ü"
//         };
//         var re = new RegExp(Object.keys(mapObj).join("|"),"gi");
//         str = str.replace(re, function(matched){
//             return mapObj[matched];
//         });
//         return str;
//     }

//     Array.prototype.contains = function(v) {
//         for(var i = 0; i < this.length; i++) {
//             if(this[i] === v) return true;
//         }
//         return false;
//     };
    
    // function timer(name) {
    //     var start = new Date();
                     
    //     console.log('+++++++++ Timer:', name, 'started');
    //     return {
    //         stop: function() {
    //             var end  = new Date();
    //             var time = end.getTime() - start.getTime();
    //             console.log('--------- Timer:', name, 'finished in', time, 'ms');
    //         }
    //     }
    // }  

// })();
  


// WEBPACK FOOTER //
// ./src/mixins/functions.js